export interface MockTopic {
  id: string;
  title: string;
  summary: string;
  category: string;
  heat: number;
  participants: number;
  publishedAt: string;
  tags: string[];
  cover: string;
  stance: { support: number; oppose: number; neutral: number };
  editorsPick?: boolean;
  comments: {
    user: string;
    avatarColor: string;
    content: string;
    likes: number;
    time: string;
    stance: 'support' | 'oppose' | 'neutral';
  }[];
}

export const mockTopics: MockTopic[] = [
  {
    id: '1001',
    title: '暑期档电影口碑两极分化，观众到底在争什么',
    summary:
      '同一部片子，有人打五星说是年度惊喜，有人打一星直言被预告片骗了。围绕剧情节奏、演员表现和宣发预期，讨论从购票平台一路吵到社交广场。',
    category: 'film',
    heat: 9842,
    participants: 3614,
    publishedAt: '2026-09-08 21:30',
    tags: ['暑期档', '观影体验', '口碑争议'],
    cover:
      'https://readdy.ai/api/search-image?query=crowded%20warm%20lit%20cinema%20hall%20interior%20with%20rows%20of%20empty%20red%20seats%20and%20a%20glowing%20screen%2C%20soft%20amber%20lighting%2C%20editorial%20photography%2C%20cozy%20atmosphere&width=800&height=560&seq=topic-film-01&orientation=landscape',
    stance: { support: 38, oppose: 34, neutral: 28 },
    editorsPick: true,
    comments: [
      {
        user: '爆米花不加糖',
        avatarColor: 'bg-primary-500',
        content: '预告片剪得太燃了，进影院发现正片节奏慢，落差感才是最劝退的。评分低不代表片子差，是我期待错了方向。',
        likes: 1284,
        time: '2小时前',
        stance: 'oppose',
      },
      {
        user: '午夜场常客',
        avatarColor: 'bg-secondary-500',
        content: '我倒觉得慢节奏是优点，第二幕的长镜头特别稳。现在大家被快剪惯坏了，耐心看进去会有惊喜。',
        likes: 962,
        time: '3小时前',
        stance: 'support',
      },
      {
        user: '票根收集者',
        avatarColor: 'bg-accent-500',
        content: '中立说一句：这类争议本质是宣发和成片不匹配。想知道值不值，建议先看网友的具体吐槽点再决定。',
        likes: 741,
        time: '4小时前',
        stance: 'neutral',
      },
      {
        user: '周末观影团',
        avatarColor: 'bg-primary-700',
        content: '我们群里八个人分成了三派，最后结论是「演员加分，剧本扣分」。希望后面能出导演剪辑版。',
        likes: 508,
        time: '5小时前',
        stance: 'neutral',
      },
    ],
  },
  {
    id: '1002',
    title: '通勤时间算不算工作时长，网友吵翻了',
    summary:
      '一段关于「到家才算下班」的讨论冲上热榜。有人认为路上也在处理消息，有人觉得这是自我感动。法与情理的两难，让评论区持续升温。',
    category: 'society',
    heat: 9210,
    participants: 4207,
    publishedAt: '2026-09-08 18:05',
    tags: ['通勤', '职场', '劳动权益'],
    cover:
      'https://readdy.ai/api/search-image?query=early%20morning%20city%20subway%20platform%20with%20blurred%20commuters%20waiting%20in%20warm%20sunlight%2C%20muted%20terracotta%20and%20cream%20tones%2C%20editorial%20documentary%20style&width=800&height=560&seq=topic-commute-02&orientation=landscape',
    stance: { support: 52, oppose: 29, neutral: 19 },
    editorsPick: true,
    comments: [
      {
        user: '地铁打工人',
        avatarColor: 'bg-primary-500',
        content: '我每天单程九十分钟，车上还在回工作消息，这难道不算工作吗？支持把路程纳入弹性工时的讨论。',
        likes: 2033,
        time: '1小时前',
        stance: 'support',
      },
      {
        user: '咖啡续命中',
        avatarColor: 'bg-accent-600',
        content: '反对把它一刀切算工时，但支持公司给通勤补贴。两者别混为一谈，讨论才有意义。',
        likes: 1176,
        time: '3小时前',
        stance: 'oppose',
      },
      {
        user: '准点下班派',
        avatarColor: 'bg-secondary-600',
        content: '关键看有没有真的在干活。如果只是戴着耳机听歌，那和加班是两回事，别自己给自己加戏。',
        likes: 654,
        time: '4小时前',
        stance: 'oppose',
      },
      {
        user: '远程办公党',
        avatarColor: 'bg-primary-700',
        content: '远程之后我才发现，省下的通勤时间可以直接变成睡眠和早餐。讨论的本质是时间怎么还被给自己。',
        likes: 512,
        time: '6小时前',
        stance: 'neutral',
      },
    ],
  },
  {
    id: '1003',
    title: '短视频推荐算法调整后，创作者在讨论流量去哪了',
    summary:
      '不少创作者发现作品的初始曝光节奏变了。有人复盘选题与完播率，有人转向长内容。围绕「内容为王还是运营为王」，讨论声量持续走高。',
    category: 'internet',
    heat: 8733,
    participants: 2988,
    publishedAt: '2026-09-07 22:14',
    tags: ['内容创作', '算法', '流量'],
    cover:
      'https://readdy.ai/api/search-image?query=creator%20desk%20with%20ring%20light%2C%20camera%20and%20colorful%20editing%20timeline%20on%20monitor%20in%20warm%20studio%20at%20night%2C%20amber%20and%20cream%20palette%2C%20editorial%20tech%20photography&width=800&height=560&seq=topic-algorithm-03&orientation=landscape',
    stance: { support: 34, oppose: 41, neutral: 25 },
    comments: [
      {
        user: '剪辑到凌晨',
        avatarColor: 'bg-secondary-500',
        content: '亲测前三秒留人的权重更高了。与其抱怨算法，不如把开场钩子做扎实，这是内容人的基本功。',
        likes: 998,
        time: '5小时前',
        stance: 'support',
      },
      {
        user: '小众垂类博主',
        avatarColor: 'bg-accent-500',
        content: '但垂类内容本身慢热，如果只看即时数据，很多好选题根本活不过冷启动期，这才是真正的痛点。',
        likes: 1320,
        time: '3小时前',
        stance: 'oppose',
      },
      {
        user: '数据罗盘',
        avatarColor: 'bg-primary-500',
        content: '建议大家做一版内容日历，把长尾和热点分开投。别把一次波动当成规律，观察两周再下结论。',
        likes: 705,
        time: '8小时前',
        stance: 'neutral',
      },
      {
        user: '深夜文案铺',
        avatarColor: 'bg-foreground-700',
        content: '流量会变，观众的信任不会。把老粉留住比追一次爆款更重要，这是我这半年最大的体会。',
        likes: 588,
        time: '昨天',
        stance: 'support',
      },
    ],
  },
  {
    id: '1004',
    title: '电竞联赛总决赛观赛人数创新高，赛后复盘引热议',
    summary:
      '决胜局的换人调整成为讨论焦点。有人夸教练敢赌，有人质疑节奏被打乱。战术派与结果派各执一词，复盘帖在深夜刷屏。',
    category: 'sports',
    heat: 8412,
    participants: 5102,
    publishedAt: '2026-09-07 01:40',
    tags: ['电竞', '总决赛', '战术复盘'],
    cover:
      'https://readdy.ai/api/search-image?query=esports%20arena%20stadium%20with%20glowing%20stage%20lights%20and%20crowd%20silhouettes%20in%20warm%20orange%20and%20cream%20tone%2C%20dramatic%20wide%20editorial%20shot&width=800&height=560&seq=topic-esports-04&orientation=landscape',
    stance: { support: 47, oppose: 33, neutral: 20 },
    comments: [
      {
        user: '票选FMVP',
        avatarColor: 'bg-primary-500',
        content: '第四局敢换人是真的需要勇气，结果证明效果立竿见影。教练组这次值得一个掌声。',
        likes: 1544,
        time: '2小时前',
        stance: 'support',
      },
      {
        user: '看回放到天亮',
        avatarColor: 'bg-secondary-600',
        content: '但换人之后的前两波团明显脱节，赢了不等于决策对。如果对面抓机会更狠，可能就是另一个结局。',
        likes: 900,
        time: '3小时前',
        stance: 'oppose',
      },
      {
        user: '数据席观察员',
        avatarColor: 'bg-accent-600',
        content: '补一句背景：这赛季该阵容的胜率本来就高。换人不算冒险，算回到更熟的打法。',
        likes: 676,
        time: '5小时前',
        stance: 'neutral',
      },
      {
        user: '解说路人粉',
        avatarColor: 'bg-foreground-700',
        content: '不管站哪边，这场决赛的观赛体验是真的顶。希望联赛把这种赛制保留下去。',
        likes: 430,
        time: '7小时前',
        stance: 'neutral',
      },
    ],
  },
  {
    id: '1005',
    title: '国产大模型开放新功能，普通用户实测反馈两极化',
    summary:
      '新版本上线后，重度用户晒出效率提升的案例，也有人吐槽部分场景答非所问。围绕「够不够用」和「该怎么用」，讨论热度稳步上涨。',
    category: 'tech',
    heat: 7980,
    participants: 2674,
    publishedAt: '2026-09-06 16:22',
    tags: ['大模型', '实测', '效率工具'],
    cover:
      'https://readdy.ai/api/search-image?query=laptop%20on%20warm%20wooden%20desk%20showing%20abstract%20glowing%20dialogue%20interface%2C%20soft%20cream%20and%20terracotta%20lighting%2C%20minimal%20editorial%20technology%20photography&width=800&height=560&seq=topic-ai-05&orientation=landscape',
    stance: { support: 44, oppose: 26, neutral: 30 },
    comments: [
      {
        user: '效率工具控',
        avatarColor: 'bg-secondary-500',
        content: '拿它做资料初稿和表格整理，效率大概翻倍。关键是把它当助手而不是当权威，心态摆正就好用。',
        likes: 869,
        time: '4小时前',
        stance: 'support',
      },
      {
        user: '较真的测试员',
        avatarColor: 'bg-primary-600',
        content: '复杂推理还是会翻车，尤其是需要精确计算的任务。宣传和实际能力之间还有差距，别吹太满。',
        likes: 1120,
        time: '6小时前',
        stance: 'oppose',
      },
      {
        user: '通勤路上学',
        avatarColor: 'bg-accent-500',
        content: '建议大家按场景分工：检索用它、核对用自己。把它放到合适的位置，比一味夸或踩都有价值。',
        likes: 640,
        time: '9小时前',
        stance: 'neutral',
      },
      {
        user: '新工具尝鲜',
        avatarColor: 'bg-foreground-700',
        content: '最惊喜的是响应速度，比半年前顺滑太多。功能还在迭代，给它一点时间。',
        likes: 402,
        time: '昨天',
        stance: 'support',
      },
    ],
  },
  {
    id: '1006',
    title: '音乐节票价与体验争议，乐迷晒账单讨论值不值',
    summary:
      '从阵容公布到现场动线，讨论从「买不买」延伸到「办不办得好」。支持者看重氛围，质疑者更在意性价比与服务细节。',
    category: 'entertainment',
    heat: 7621,
    participants: 3390,
    publishedAt: '2026-09-05 20:11',
    tags: ['音乐节', '现场体验', '演出市场'],
    cover:
      'https://readdy.ai/api/search-image?query=outdoor%20music%20festival%20crowd%20at%20sunset%20with%20warm%20stage%20lights%20and%20raised%20hands%2C%20golden%20amber%20tone%2C%20editorial%20live%20photography&width=800&height=560&seq=topic-festival-06&orientation=landscape',
    stance: { support: 40, oppose: 37, neutral: 23 },
    comments: [
      {
        user: '前排蹦迪选手',
        avatarColor: 'bg-primary-500',
        content: '现场氛围真的拉满，跟着几万人一起唱的感觉，线上永远替代不了。这笔钱对我来说值。',
        likes: 1055,
        time: '5小时前',
        stance: 'support',
      },
      {
        user: '精打细算乐迷',
        avatarColor: 'bg-accent-600',
        content: '票价涨了但补给点、洗手间和退场动线没跟上，体验打折才是大家不开心的原因，别只谈情怀。',
        likes: 1288,
        time: '4小时前',
        stance: 'oppose',
      },
      {
        user: '带相机的人',
        avatarColor: 'bg-secondary-600',
        content: '补个信息：这次主办方增加了两个补给点，比去年好一些。建议分时段进场，体验会明显改善。',
        likes: 512,
        time: '8小时前',
        stance: 'neutral',
      },
      {
        user: '老乐迷一枚',
        avatarColor: 'bg-foreground-700',
        content: '演出市场热起来是好事，但热度越高越要守住服务底线，不然口碑透支得也快。',
        likes: 398,
        time: '昨天',
        stance: 'neutral',
      },
    ],
  },
  {
    id: '1007',
    title: '「先看评分再决定」成观影习惯，评分体系还该不该信',
    summary:
      '越来越多人出门前先刷一遍评分。但当分数被情绪和小样本带偏，观众又该怎么判断？从打分机制到刷分现象，讨论层层展开。',
    category: 'film',
    heat: 7180,
    participants: 2811,
    publishedAt: '2026-09-04 19:48',
    tags: ['评分', '观影习惯', '口碑'],
    cover:
      'https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20five%20star%20rating%20interface%20held%20in%20hand%20against%20warm%20blurred%20city%20lights%2C%20cream%20and%20amber%20palette%2C%20editorial%20lifestyle%20photo&width=800&height=560&seq=topic-rating-07&orientation=landscape',
    stance: { support: 36, oppose: 40, neutral: 24 },
    comments: [
      {
        user: '选片谨慎党',
        avatarColor: 'bg-secondary-500',
        content: '我会看评分分布而不是平均分，中间段集中说明质量稳定，两极分化才需要警惕。',
        likes: 776,
        time: '6小时前',
        stance: 'support',
      },
      {
        user: '随机观影派',
        avatarColor: 'bg-primary-600',
        content: '太依赖评分反而会错过小众好片。别人打的分是别人的口味，我的两小时我自己负责。',
        likes: 934,
        time: '5小时前',
        stance: 'oppose',
      },
      {
        user: '数据爱好者',
        avatarColor: 'bg-accent-500',
        content: '建议看近三天的评论而不是总量，热度期的短评更能反映真实观感，样本也更新鲜。',
        likes: 588,
        time: '10小时前',
        stance: 'neutral',
      },
      {
        user: '老电影院人',
        avatarColor: 'bg-foreground-700',
        content: '评分只是参考。真正好用的是看几个和你口味接近的影评人怎么说，比看总分靠谱。',
        likes: 421,
        time: '昨天',
        stance: 'neutral',
      },
    ],
  },
  {
    id: '1008',
    title: '城市夜间市集人气回升，摊主与游客各有说法',
    summary:
      '入秋后夜间市集重新热闹起来。游客说烟火气回来了，摊主更关心租金与客流稳定性。讨论从「要不要去」变成「怎么长久办下去」。',
    category: 'society',
    heat: 6894,
    participants: 2456,
    publishedAt: '2026-09-03 21:02',
    tags: ['夜间经济', '市集', '城市生活'],
    cover:
      'https://readdy.ai/api/search-image?query=bustling%20evening%20street%20night%20market%20with%20warm%20string%20lights%2C%20small%20food%20stalls%20and%20strolling%20crowd%2C%20cozy%20amber%20and%20cream%20tones%2C%20editorial%20travel%20photo&width=800&height=560&seq=topic-market-08&orientation=landscape',
    stance: { support: 55, oppose: 22, neutral: 23 },
    comments: [
      {
        user: '夜宵地图君',
        avatarColor: 'bg-accent-500',
        content: '最大的变化是有秩序了，摊位间距合理、垃圾清理也及时。烟火气和整洁其实可以兼得。',
        likes: 923,
        time: '7小时前',
        stance: 'support',
      },
      {
        user: '摆摊的老周',
        avatarColor: 'bg-primary-700',
        content: '游客看到的是热闹，我们看到的是周末旺、工作日冷。希望租金别跟着热度一起涨太快。',
        likes: 1103,
        time: '5小时前',
        stance: 'oppose',
      },
      {
        user: '城市漫步者',
        avatarColor: 'bg-secondary-600',
        content: '建议分片区错峰办，别把人都挤在一条街。缓解拥挤，游客体验和摊主生意都会更好。',
        likes: 470,
        time: '9小时前',
        stance: 'neutral',
      },
      {
        user: '带娃逛夜市',
        avatarColor: 'bg-foreground-700',
        content: '带小孩最在意安全和卫生，这两点做到了我们每周都愿意来，消费也更放心。',
        likes: 356,
        time: '昨天',
        stance: 'support',
      },
    ],
  },
];